import React from 'react';
import ReactDOM from 'react-dom'

export default class Iframe extends React.Component {

  initialState = {
    content: "",
    iFrameHeight: 100
  }

  state = this.initialState

  componentWillMount() {
    this.setState({
      content: this.props.content
    })
    window.addEventListener('message', this.handleIframeMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeMessage);
  }  

  handleIframeMessage = (e) => {
    console.log("handleIframeMessage",e)
    let data = e && e.data
    if (data && data.type == "height" && parseInt(data.value)) {
      this.setState({iFrameHeight: parseInt(data.value)})
    }
  }

  handleChange = (e) => {
    el.content = e.target.value
    this.setState({content: e.target.value});    
  }

  render() {
    let editMode = this.props.mode == 'edit'
    let content = editMode ? this.state.content || this.props.content : this.props.content
    if (typeof content != "string") content = "";
    if (this.props.iframes && this.props.iframes.length > 0 && !content)
      content = this.props.iframes[0].value
    this.props.el.content = content
    let d = window.iframeData || {}
    let src = content
      .replace("{wid}",d.wid || "")
      .replace("{subaffiliate}",d.subaffiliate || "")
      .replace("{click_id}",d.click_id || "")
      .replace("{agent}",d.agent || "")
      .replace("{ip}",d.ip || "")    
    let iframe = src && <iframe 
      src={src} 
      frameBorder="0"
      scrolling="no"
      seamless="seamless"
      width="360"
      height={this.state.iFrameHeight} 
      ref={ref => this.iframe = ref}     
      // style="width:360px;height:640px;"      
    />
    if (editMode) {
      return (
        <div class="text-center" style={{height: "inherit"}}>
          {iframe}
          <div class="mt-2">
            <select class="form-control" value={content} onChange={this.handleChange}>
              {this.props.iframes && this.props.iframes.map((item,i) =>
                <option key={i} value={item.value}>{item.name}</option>
              )}
            </select>
          </div>                    
        </div>
      )
    } else if (content) {
      return <div class="text-center">{iframe}</div>;
    } else {
      return <div></div>
    }
  }

}